import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';

const { getSaleType, getPickupTime, getBufferPickupTime } = OrderingSelectors;
const { fetchOrderingProviderDetails } = OrderingOperations;
const { CATERING_SALE_TYPES } = OrderingConstants;

export const refreshOrderingProviderDetails = createAsyncThunk(
  'refreshOrderingProviderDetails',
  async (_, { dispatch, getState }) => {
    const state = getState() as EntireFrontendState;
    const saleType = getSaleType(state);
    const pickupTime = getPickupTime(state);
    const bufferPickupTime = getBufferPickupTime(state);

    const isCatering = CATERING_SALE_TYPES.includes(saleType);
    const effectivePickupTime = pickupTime || (isCatering ? bufferPickupTime : undefined);
    const orderDate = effectivePickupTime ? moment(effectivePickupTime).format('l') : undefined;

    await dispatch(fetchOrderingProviderDetails({ bufferMode: false, date: orderDate }));
  },
);
